import { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const container: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const filterBox: SxStyleFunc = (open: boolean) => ({
  border: (p) =>
    open ? `1px solid ${p.palette.primary.main}` : `1px solid transparent`,
  marginLeft: '1px',
});

export const emptyStateWrapper: SxStyle = {
  marginTop: 5,
};
